<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  *ngIf="fsJob"
  id="fs-details"
  class="col bg-white u-shadow">
  <div class="o-tech-table__header">
    {{ "fieldservice.details" | translate }}
  </div>
  <div class="o-tech-table__container">
    <table class="o-tech-table">
      <tbody>
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "fieldservice.contactperson" | translate }}
          </td>
          <td class="o-tech-table__description">{{ fsJob.contactPerson }}</td>
        </tr>
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "fieldservice.maintechnician" | translate }}
          </td>
          <td class="o-tech-table__description">
            {{ fsJob.employee | titlecase }}
          </td>
        </tr>
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "fieldservice.status" | translate }}
          </td>
          <td class="o-tech-table__description">
            {{
              (fsJob.status === "Planned"
                ? "fieldservice.statusplanned"
                : "fieldservice.statuslast"
              ) | translate
            }}
          </td>
        </tr>
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "fieldservice.technicians" | translate }}
          </td>
          <td class="o-tech-table__description">
            <div
              class="c-chip"
              *ngFor="let t of fsJob.technicians">
              {{ t }}
            </div>
          </td>
        </tr>
        <tr
          *ngIf="fsJob?.scopeWork"
          class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "fieldservice.scopeofwork" | translate }}
          </td>
          <td class="o-tech-table__description">
            <pre>{{ fsJob.scopeWork }}</pre>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- <div *ngIf="fsJob?.scopeWork" id="fs-scopeofwork" class="col bg-white u-shadow">
    <div class="o-tech-table__header">{{ 'fieldservice.scopeofwork' | translate }}</div>
    <div class="o-tech-table__container">
        <table class="o-tech-table">
            <tbody>
                <tr class="o-tech-table__item">
                    <td class="o-tech-table__description">
                        <pre>{{ fsJob.scopeWork }}</pre>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div> -->
